import React from 'react';
import { Grid } from '@mui/material';
import Intro from './Intro';
import Course from './Course';

export default function Courses() {
    return (
        <Grid container flexWrap={'nowrap'} direction={'column'} alignItems={'center'}
            justifyContent={'center'}>
            <Intro />
            <Course />
        </Grid>
    )
}
